import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import { decode } from 'punycode';
import 'rxjs/add/operator/do';
import { Storage } from '@ionic/storage';
import { Events, MenuController, Nav, NavController } from 'ionic-angular';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  authToken:any
  constructor(public storage: Storage, public events:Events, public menu: MenuController) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler):Observable<HttpEvent<any>>{
    return this.getAuthToken().mergeMap((value) => {
      this.authToken = value
      const headers = new HttpHeaders({
        'x-access-token' : `${this.authToken || null}`,
      });
      request = request.clone({headers});
      //return next.handle(request);
      return next
      .handle(request)
      .do((ev: HttpEvent<any>) => {
        if (ev instanceof HttpResponse) {
          //console.log('processing response', ev);
        }
      },(err: any) => {
        if (err instanceof HttpErrorResponse) {

          if (err.status === 401 || err.status === 403) {
            this.storage.remove('hasLoggedIn');
            this.storage.remove('userId');
            this.storage.remove('username');
            this.storage.remove('usertype');
            this.storage.remove('auth_token');
            this.storage.remove('organisationId');
            this.events.publish('user:logout');
            this.menu.enable(false)
          }
        }
      });
    });
  }  

  getAuthToken(): Observable<any> {
    return Observable.fromPromise(
      this.storage.get('auth_token')
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/token-interceptor.ts